import { VerticalAlignBottomRounded } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { styled as MuiStyled } from '@mui/material/styles';
import { Box } from '@mui/system';

const thumb = (layoutType) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: layoutType === 'mobile' ? '75px' : '4rem',
  height: layoutType === 'mobile' ? '75px' : '4rem',
  alignItems: 'center'
  // margin: layoutType === 'mobile' ? '0 4px 4px' : '0 0.75rem'
  // overflow: 'hidden'
});

const thumbInner = (isNotShowable, layoutType, isDownloaded) => ({
  display: 'flex',
  overflow: 'hidden',
  borderRadius: '4px',
  border:
    isNotShowable && isDownloaded
      ? 'none'
      : isDownloaded
      ? '1px solid #E5EBF3'
      : '1px solid #D1DBE8',
  width: layoutType === 'mobile' ? '75px' : '4rem',
  height: layoutType === 'mobile' ? '56px' : '4rem',
  backgroundColor: !isDownloaded ? '#E9EDF5' : '#fff',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative'
});

const img = (isNotShowable, layoutType) => ({
  display: 'block',
  width: isNotShowable ? '3rem' : '100%',
  height: isNotShowable ? (layoutType === 'mobile' ? '40px' : '3rem') : '100%',
  margin: isNotShowable && '0 auto'
});

const footer = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'end'
};

const thumbsContainer = {
  width: '100%',
  height: '100%',
  display: 'flex',
  // justifyContent: 'space-between',
  flexDirection: 'row',
  flexWrap: 'wrap',
  position: 'relative',
  gap: '1.5rem'
};
const fileNameTypo = (theme, layoutType) => ({
  width: layoutType === 'mobile' ? '60px' : '4.75rem',
  color: theme.text.secondary.color,
  overflow: 'hidden',
  mr: '2px',
  textAlign: 'center'
});

const closeFile = (theme, layoutType) => ({
  display: 'flex',
  width: layoutType === 'mobile' ? '15px' : '1rem',
  height: layoutType === 'mobile' ? '15px' : '1rem',
  color: theme.icon.grey.color
});

const DownloadIconWrapper = MuiStyled(Box)`
      width: ${(props) => (props.layoutType === 'mobile' ? '24px' : '1.5rem')};
      height: ${(props) => (props.layoutType === 'mobile' ? '24px' : '1.5rem')};
      background-color: white;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.3s all ease;
    
      &:hover {
        width: ${(props) => (props.layoutType === 'mobile' ? '32px' : '2rem')};
        height: ${(props) => (props.layoutType === 'mobile' ? '32px' : '2rem')};
      }
    `;

const DownloadIcon = MuiStyled(VerticalAlignBottomRounded)`
      width: ${(props) => (props.layoutType === 'mobile' ? '24px' : '1.5rem')};
      height: ${(props) => (props.layoutType === 'mobile' ? '24px' : '1.5rem')};
      padding: 4px;
      color: ${(props) => props.theme.palette.green.main};
      transition: 0.3s all ease;
      cursor: pointer;
    
      &:hover {
        width: ${(props) => (props.layoutType === 'mobile' ? '32px' : '2rem')};
        height: ${(props) => (props.layoutType === 'mobile' ? '32px' : '2rem')};
      }
    `;

// ******************************** end styled components ***********************************
const actionIconsWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '.2rem',
  borderRadius: '2px'
};

const baseStyle = (
  theme,
  isPreviewMode,
  // height,
  layoutType,
  isHover,
  readOnly
) => ({
  width: '100%',
  minHeight: '100%',
  padding: readOnly ? 0 : layoutType === 'mobile' ? '12px' : '1.5rem',
  border:
    !isPreviewMode &&
    `2px dashed ${isHover ? '#80BADB' : theme.card.border.color}`,
  borderRadius: '.25rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: readOnly
    ? 'transparent'
    : isHover
    ? theme.name === 'DARK'
      ? theme.wrapper.uploader.backgroundColor
      : '#F3FBFE'
    : isPreviewMode && theme.wrapper.uploader.backgroundColor,
  // height,
  transition: '0.3s all ease',
  cursor: readOnly ? 'auto' : 'pointer',
  position: 'relative'
});

const acceptStyle = {
  backgroundColor: 'rgba(0, 256, 0, 0.1)'
};

const rejectStyle = {
  backgroundColor: 'rgba(256, 0, 0, 0.1)'
};
// const StyledDivider = styled(Divider)(() => ({
//   '&::before': {
//     borderTopStyle: 'dashed'
//   },
//   '&::after': {
//     borderTopStyle: 'dashed'
//   }
// }));
const CustomTypographyTertiary = MuiStyled(Typography)`
    color: ${(props) => props.theme.text.tertiary.color};
    font-size: 0.625rem;
    font-weight: 500;
    line-height: 1rem;
    text-align: center;
    ;
  `;
const closeAll = (theme) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  color: theme.icon.grey.color,
  borderRadius: '50%',
  '& :hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease'
  }
});
export {
  acceptStyle,
  actionIconsWrapper,
  baseStyle,
  closeAll,
  closeFile,
  CustomTypographyTertiary,
  DownloadIcon,
  DownloadIconWrapper,
  fileNameTypo,
  footer,
  img,
  rejectStyle,
  // StyledDivider,
  thumb,
  thumbInner,
  thumbsContainer
};
